import { getApiUrl } from '../config/env';

const trimTrailingSlash = (value: string) => value.replace(/\/$/, '');

export const getBackendBaseUrl = () => {
  const apiUrl = getApiUrl() || 'http://localhost:4444/api/graphql';
  return trimTrailingSlash(apiUrl.replace(/\/api\/graphql$/, ''));
};

export const buildGoogleAuthUrl = () => {
  const returnTo = `${window.location.pathname}${window.location.search}`;
  const url = new URL('/auth/google', getBackendBaseUrl());
  url.searchParams.set('returnTo', returnTo);
  return url.toString();
};

export const startGoogleLogin = () => {
  window.location.assign(buildGoogleAuthUrl());
};
